<template>
    <div class="thank-you" :style="style">
        <div v-if="showDefault">
            <h3>Thank You!</h3>
            <p>Your submission has been accepted and we will be in contact shortly.</p>
        </div>
        <div v-else>
            <h3 v-if="title">{{title}}</h3>
            <p v-if="message">{{message}}</p>
        </div>
    </div>
</template>

<script>
export default {
  props: ['height','message', 'title'],
  computed: {
    style() {
      const height = this.height ? this.height + 'px;' : '100%';
      return `height: ${height}`;
    },
    showDefault() {
      return !this.message && !this.title;
    }
  }
};
</script>
